export default __webpack_public_path__ + "static/media/gallery_08.dab759b8.jpg";